import React, { useEffect } from 'react';
import usePricingLogic from './PricingLogic';
import PricingView from './PricingView';
import { trackPageView } from '../../services/analyticsService';

const Pricing = () => {
  // Use pricing logic
  const pricingLogic = usePricingLogic();
  
  useEffect(() => {
    // Track pricing page view - important for conversion analysis
    trackPageView('Pricing Page');
  }, []);
  
  // Pass data to view
  return <PricingView 
    billingPeriod={pricingLogic.billingPeriod}
    toggleBillingPeriod={pricingLogic.toggleBillingPeriod}
    plans={pricingLogic.plans}
    loading={pricingLogic.loading}
    isProcessingPayment={pricingLogic.isProcessingPayment}
    handleSubscribe={pricingLogic.handleSubscribe}
    activeSubscription={pricingLogic.activeSubscription}
    checkAllPrices={pricingLogic.checkAllPrices}
    checkYearlyPrice={pricingLogic.checkYearlyPrice}
    updatePriceId={pricingLogic.updatePriceId}
    developerMode={pricingLogic.developerMode}
    useStripePlans={pricingLogic.useStripePlans}
    togglePlanSource={pricingLogic.togglePlanSource}
  />;
};

export default Pricing; 